import { render, staticRenderFns } from "./TwoFactorsAuthV2.vue?vue&type=template&id=22b282ec&scoped=true"
import script from "./TwoFactorsAuthV2.vue?vue&type=script&lang=js"
export * from "./TwoFactorsAuthV2.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorsAuthV2.vue?vue&type=style&index=0&id=22b282ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b282ec",
  null
  
)

export default component.exports